const config = {
    // WhiteLable: "royal777.maruti.dev",
    WhiteLable: window.location.hostname,
    basicData: {},
    AdminUrl:sessionStorage.getItem('adminUrl') || '',
    bannerOpen:localStorage.getItem("bannerOpen") ? `${localStorage.getItem("bannerOpen")}` :'false' ,
    logoDetails:localStorage.getItem("logoDetails") ? `${localStorage.getItem("logoDetails")}` :[] ,
    pubObj:[],
    TabCricket:'cricket',
    TabFootball:'football',
    TabTennis:'tennis',
    TabKabaddi:'kabaddi',
    TabElection:'election',
    TabHorseRacing:'horseracing',
    TabGreyhoundRacing:'greyhound',
    lay:"LAY",
    back:"BACK",
    fancy:"FANCY",
    isNotfancy:"NO-FANCY",
    updateStackMsg:"Stack Update Successfully",
    stackPopupHeading:"SET BUTTON STAKE",
    MATCH_ODDS:"MATCH_ODDS",
    BOOKMAKER:"BOOKMAKER",
    BOOKMAKER:"BOOKMAKER",
    TOSS:"TOSS",
    FANCY:"FANCY",
    UPCOMING:"UPCOMING",
    INPLAY:"IN-PLAY",
    DATA:{},
    betPlaceURL:`${process.env.REACT_APP_BASE_URL}/api/v1/bets/placeBet`,
    wssLink: `${process.env.REACT_APP_BASE_URL == "https://staging-api.maruti.dev" ? 'wss://fancy-api.maruti.dev/':"wss://ag-api.superexch.app/"}`,
    typeNormal:'NORMAL',
    typeSession:'OVERS',
    typeOnlyOver:'SINGLE_OVER',
    typeWPmarket:'BATSMAN',
    typeOddEven:'ODD_EVEN',
    typeWinningSeat:'WINNING_SEATS',
    typeBallbyBall:'BALL_BY_BALL',
    typeXtraMarket:'OTHER',
    typeKHADO:'KHADO',
    typeMETER:'METER',
    getDateFormated :'dd-MM-yyyy',
    defualtGame : "Mac88 Gaming",
    Topic_Match_Odds:'/topic/bfrate_match_odds_update/',
    Topic_Bookmaker:'/topic/bfrate_bm_update/',
    Topic_Fancy:'/topic/bfrate_fancy_update/',
    Topic_Exchnage:`/topic/bfrate_exchange`,
    Topic_LiveExch:`/topic/bfrate_liveexchange`,
    fancyMinMaxTime:15000,
    matchOddsMinMaxTime:15000,
    bookmakerMinMaxTime:15000,
    maintanaceTime:15000,
    homeDAta:undefined,
    api_url:process.env.REACT_APP_ENV === 'development' ? `${process.env.REACT_APP_BASE_URL}` : `${process.env.REACT_APP_BASE_URL}`,
  };
  
  export default config;
  